var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialogWindow',{ref:"errorCommonDialog",attrs:{"size":"max","title":_vm.sysmsgTitle,"detail":_vm.sysmsgText,"color":"error"},on:{"select-ok":function($event){return _vm.$emit('onConfirmSysmsg')}}})}
var staticRenderFns = []

export { render, staticRenderFns }